import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import ambiente from '../../config/ambienteConfig';
import { exibirMensagem } from '../../redux/actions/mensagemAction';

class ProventosAtivoAnual extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            proventos: {},
            ano: moment().year(),
            anos: []
        };
    }

    componentDidMount = async () => {
        await this.atualizarCarteira();
        let anos = [];
        for(let i = 2005; i <= 2020; i++) {
            anos.push(i);
        }
        this.setState({anos});
    }

    atualizarCarteira = async () => {
        try {
            const res = await axios.get(`${ambiente.dev.server}/proventos/anual?ano=${this.state.ano}`);
            this.setState({ proventos: res.data });
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    handleChangeData = async ano => {
        await this.setState({ano});
		this.atualizarCarteira();
	}
    
    render() {
        return (
            <div>
                <div className="form-group col">
                        <select className="form-control" value={this.state.ano} onChange={evt => this.handleChangeData(evt.target.value)}>
                            <option value="">Escolha um ano</option>
                            {this.state.anos.map(item => <option key={item} value={item}>{item}</option>)}
                        </select>
                    </div>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Ativo</th>
                            <th>Dividendos</th>
                            <th>JSP</th>
                            <th>Aluguéis</th>
                            <th>Cupons</th>
                            <th>Rendimentos</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.proventos.acoes && this.state.proventos.acoes.lista.map(item => {
                            return (
                                <tr key={item.ativo}>
                                    <td>{item.ativo}</td>
                                    <td>{parseFloat(item.dividendos).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{parseFloat(item.jcp).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{parseFloat(item.aluguel).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{parseFloat(item.cupom).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{parseFloat(item.rendimentos).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{parseFloat(item.total).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td>Totais</td>
                            <td>{parseFloat(this.state.proventos.acoes && this.state.proventos.acoes.dividendos).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            <td>{parseFloat(this.state.proventos.acoes && this.state.proventos.acoes.jcp).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            <td>{parseFloat(this.state.proventos.acoes && this.state.proventos.acoes.aluguel).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            <td>{parseFloat(this.state.proventos.acoes && this.state.proventos.acoes.cupom).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            <td>{parseFloat(this.state.proventos.acoes && this.state.proventos.acoes.rendimentos).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            <td>{parseFloat(this.state.proventos.acoes && this.state.proventos.acoes.total).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                        </tr>
                    </tbody>
                </table>

                <table className="table">
                    <thead>
                        <tr>
                            <th>Ativo</th>
                            <th>Dividendos</th>
                            <th>JSP</th>
                            <th>Aluguéis</th>
                            <th>Cupons</th>
                            <th>Rendimentos</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.proventos.fiis && this.state.proventos.fiis.lista.map(item => {
                            return (
                                <tr key={item.ativo}>
                                    <td>{item.ativo}</td>
                                    <td>{parseFloat(item.dividendos).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{parseFloat(item.jcp).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{parseFloat(item.aluguel).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{parseFloat(item.cupom).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{parseFloat(item.rendimentos).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{parseFloat(item.total).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td>Totais</td>
                            <td>{parseFloat(this.state.proventos.fiis && this.state.proventos.fiis.dividendos).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            <td>{parseFloat(this.state.proventos.fiis && this.state.proventos.fiis.jcp).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            <td>{parseFloat(this.state.proventos.fiis && this.state.proventos.fiis.aluguel).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            <td>{parseFloat(this.state.proventos.fiis && this.state.proventos.fiis.cupom).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            <td>{parseFloat(this.state.proventos.fiis && this.state.proventos.fiis.rendimentos).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            <td>{parseFloat(this.state.proventos.fiis && this.state.proventos.fiis.total).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

ProventosAtivoAnual.propTypes = {
    exibirMensagem: PropTypes.func.isRequired,
  };
  
  function mapStateToProps(state) {
    return {
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto)),
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(ProventosAtivoAnual);


// WEBPACK FOOTER //
// ./src/components/proventos/ProventosAtivoAnual.js